import React, { useContext, useEffect, useState } from 'react';
import CustomInput from '../../../../../components/CustomInputs/CustomInput';
import CustomSelectInput from '../../../../../components/CustomSelectInput/CustomSelectInput';
import client from '../../../../../api/client';
import { UserContext } from '../../../../../contexts/UserContext';
import showToast from '../../../../../components/CustomToast/toastHelper';
import icon from '../../../../../assets/shareholdersIcon.png'

interface AddNewAccountProps {
  close: () => void;
  refreshPage: ()=>void
}

const AddNewAccount = ({ close, refreshPage }: AddNewAccountProps) => {
  const [banks, setBanks] = useState<any[]>([]);
  const [inputs, setInputs] = useState({
    accountType: 'Savings',
    bankCode: '',
    accountNumber: '',
    subsidiaryId: 0,
    bankId: ''
  });
  const [requestType, setRequestType] = useState<string>('bankCode');
  const [selectedBank, setSelectedBank] = useState<any>();
  const [account, setAccount] = useState<any>({});

  const { userDetails } = useContext(UserContext) ?? {};

  useEffect(() => {
    const fetchData = async () => {
      await fetchBanks();
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (inputs.accountNumber.length === 10) {
      resolveAccount();
    }else{
      account.accountname=''
    }
  }, [inputs.accountNumber]);

  useEffect(() => {
    if (userDetails?.activeSubsidiary) {
      const { activeSubsidiary } = userDetails;
      setInputs((prevInputs) => ({
        ...prevInputs,
        subsidiaryId: activeSubsidiary.id
      }));
    }
  }, [userDetails]);

  const fetchBanks = async () => {
    try {
      const response = await client.get('/subsidiary/dashboard/banks');
      setBanks(response.data.banks);
    } catch (err: any) {
      if (err?.response?.data?.message === 'Please login again') {
        sessionStorage.clear();
        window.location.href = '/';
      } else {
        console.error('error getting data', err);
      }
    }
  };

  const resolveAccount = async () => {
    const payload = {
      accountNumber: inputs.accountNumber,
      bankCode: selectedBank?.bankCode
    };
    try {
      const response = await client.post('/subsidiary/payout/account/resolve', payload);
      setAccount(response.data.data);
    } catch (err: any) {
      if (err?.response?.data?.message === 'Please login again') {
        sessionStorage.clear();
        window.location.href = '/';
      } else {
        console.error('error getting data', err);
      }
    }
  };

  const addNewAccount = async () => {
    const payload = {
      accountType: inputs.accountType,
      subsidiaryId: inputs.subsidiaryId,
      bankId: selectedBank?.id,
      accountNumber: inputs.accountNumber,
      accountName: account.accountname
    };

    try {
      const response = await client.post('/subsidiary/dashboard/onboarding/bank/details', payload);
      const message = response?.data?.message;
      showToast(message, 'success');
      close();
      refreshPage()
    } catch (err: any) {
      if (err?.response?.data?.message === 'Please login again') {
        sessionStorage.clear();
        window.location.href = '/';
      } else {
        const message = err?.response?.data?.message;
        console.error('error getting data', err);
        showToast(message, 'error');
      }
    }
  };

  return (
    <div>
      <div className='mb-6'>
        <img src={icon} className='my-3' alt="icon" />
        <div className='my-3'>
          <p className='text-xl font-bold'>Add New Beneficiary</p>
          <p className='text-sm'>Kindly fill in the information needed</p>
        </div>
      </div>
      <div>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-4 my-3'>
          <CustomSelectInput label='Account Type' name='accountType' items={['Savings', 'Current']} onChange={(data) => setInputs({ ...inputs, accountType: data })} />
          <CustomSelectInput
            label='Bank'
            name='bank'
            items={banks}
            value={requestType === 'bankId' ? selectedBank?.id : selectedBank?.bankCode}
            displayKey='name'
            valueKey={requestType === 'bankId' ? 'id' : 'bankCode'}
            onChange={(data) => {
              const bank = banks.find((bank) => bank[requestType === 'bankId' ? 'id' : 'bankCode'] === data);
              setSelectedBank(bank);
              if (requestType === 'bankCode') {
                setInputs({ ...inputs, bankCode: bank?.bankCode });
              } else {
                setInputs({ ...inputs, bankId: bank?.id });
              }
            }}
          />
        </div>
        <CustomInput label='Account Number' name='accountNumber' onChange={(e: any) => {
          setInputs({ ...inputs, accountNumber: e.target.value });
          setRequestType('bankCode'); // Set requestType for resolving account
        }} />
        <CustomInput label='Account Name' name='accountName' value={account.accountname ?? ''} />
      </div>
      <div className='flex gap-4'>
        <button className='w-1/4 border px-6 py-3 rounded-lg text-md font-semibold' onClick={() => close()}>Cancel</button>
        <button className='w-3/4 border px-6 py-3 rounded-lg bg-custom-button-green text-md font-semibold hover:bg-green-900 hover:text-white' onClick={() => {
          setRequestType('bankId'); // Set requestType for adding new account
          addNewAccount();
        }}>Add New Beneficiary</button>
      </div>
    </div>
  );
};

export default AddNewAccount;
